import { Component, OnInit } from '@angular/core';
import { ContactFormModel } from './contact-form-model';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  ContactFormModel = new ContactFormModel("","","","");
  contactForm(formValue){
    console.log(formValue)
  }

}
